export enum NAME_BY_TAG {
  AGE5YR15YR = "5 Years To 15 Years",
  AGE50YR60YR = "50 Years To 60 Year",
  AGE2YR5YR = "2 Years To 5 Years",
  AGE15YR20YR = "15 Years To 20 Years",
}

export enum DESCRIPTION_BY_STATUS {
  "COMPLETED" = "No Errors",
  "MISSING" = "Missing",
  "NOT CONFIGURED" = "Not Configured",
  "EXTRA" = "Extra",
}

export enum STATUS {
  "COMPLETED" = "Completed",
  "MISSING" = "Failed",
  "NOT CONFIGURED" = "Failed",
  "EXTRA" = "Completed",
}

export enum STATUS_VARIANT {
  "COMPLETED" = "primary",
  "MISSING" = "danger",
  "NOT CONFIGURED" = "danger",
  "EXTRA" = "primary",
}

export const CONFIGURED = "Configured";
export const NOT_CONFIGURED = "Not_Configured";
export const ALL = "All";
